var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgConclusion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 416,
    viewBox: "0 0 464 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4231 415.897L67.2074 416L222.817 94.6716L233.436 99.9534L80.4231 415.897Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.835 415.897L395.717 416L242.441 94.6716L231.823 99.9534L384.835 415.897Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.258 64.0624H227.43V416H239.258V64.0624Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4231 413.194L67.2074 413.297L222.817 94.4393L233.436 99.6779L80.4231 413.194Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.835 413.194L395.717 413.297L242.441 94.4393L231.823 99.6779L384.835 413.194Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.258 64.0624H227.43V413.297H239.258V64.0624Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 35.6803C228.007 35.6803 224.178 34.0855 221.355 31.2468C218.532 28.408 216.946 24.5578 216.946 20.5432V15.1371C216.946 11.1225 218.532 7.27231 221.355 4.43356C224.178 1.5948 228.007 0 232 0C235.993 0 239.822 1.5948 242.645 4.43356C245.468 7.27231 247.054 11.1225 247.054 15.1371V20.5432C247.054 24.5578 245.468 28.408 242.645 31.2468C239.822 34.0855 235.993 35.6803 232 35.6803ZM232 3.78428C229.005 3.78428 226.134 4.98037 224.016 7.10944C221.899 9.23851 220.709 12.1261 220.709 15.1371V20.5432C220.709 23.5542 221.899 26.4418 224.016 28.5709C226.134 30.6999 229.005 31.896 232 31.896C234.995 31.896 237.866 30.6999 239.984 28.5709C242.101 26.4418 243.291 23.5542 243.291 20.5432V15.1371C243.291 12.1261 242.101 9.23851 239.984 7.10944C237.866 4.98037 234.995 3.78428 232 3.78428Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 12.7043H0V230.57H464V12.7043Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.43 16.7589H4.57011V223.272H459.43V16.7589Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.29 23.2462H12.635V211.379H450.29V23.2462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.581 30.004H349.177V165.254H349.581C358.414 165.254 367.16 163.505 375.32 160.106C383.481 156.707 390.896 151.726 397.142 145.445C403.387 139.165 408.342 131.71 411.722 123.505C415.102 115.299 416.842 106.505 416.842 97.6236C416.842 88.7422 415.102 79.9478 411.722 71.7425C408.342 63.5372 403.387 56.0817 397.142 49.8017C390.896 43.5216 383.481 38.54 375.32 35.1412C367.16 31.7425 358.414 29.9932 349.581 29.9932V30.004Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.177 30.0146C331.481 30.121 314.54 37.2367 302.026 49.8188C289.513 62.4009 282.436 79.4353 282.33 97.2288H349.177V30.0146Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.685 97.9479C278.685 98.0884 278.685 98.229 278.685 98.375C278.686 117.016 286.022 134.899 299.092 148.121C312.161 161.342 329.902 168.827 348.441 168.941V97.9479H278.685Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.707 98.856C280.707 98.9911 280.707 99.1263 280.707 99.2614C280.706 117.126 287.736 134.264 300.261 146.935C312.785 159.605 329.787 166.778 347.554 166.886V98.856H280.707Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.061 36.4912H25.27V45.7248H155.061V36.4912Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.807 51.6013H25.27V60.8349H232.807V51.6013Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.807 66.7113H25.27V75.9449H232.807V66.7113Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.807 81.8269H25.27V91.0605H232.807V81.8269Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19 186.24H373.673V200.837H388.19V186.24Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.418 189.484H394.104V198.134H441.418V189.484Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.928 186.24H291.411V200.837H305.928V186.24Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.156 189.484H311.842V198.134H359.156V189.484Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.355 186.24H211.838V200.837H226.355V186.24Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.583 189.484H232.269V198.134H279.583V189.484Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.747 111.258H109.172V184.619H113.747V111.258Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.506 111.258H120.93V184.619H125.506V111.258Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.27 111.258H132.694V184.619H137.27V111.258Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.028 111.258H144.453V184.619H149.028V111.258Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.398 163.708C116.089 163.708 119.893 159.884 119.893 155.166C119.893 150.449 116.089 146.625 111.398 146.625C106.706 146.625 102.903 150.449 102.903 155.166C102.903 159.884 106.706 163.708 111.398 163.708Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.156 142.683C127.848 142.683 131.651 138.859 131.651 134.142C131.651 129.424 127.848 125.6 123.156 125.6C118.465 125.6 114.661 129.424 114.661 134.142C114.661 138.859 118.465 142.683 123.156 142.683Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92 153.198C139.612 153.198 143.415 149.374 143.415 144.657C143.415 139.939 139.612 136.115 134.92 136.115C130.229 136.115 126.425 139.939 126.425 144.657C126.425 149.374 130.229 153.198 134.92 153.198Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.679 123.854C151.371 123.854 155.174 120.03 155.174 115.312C155.174 110.595 151.371 106.771 146.679 106.771C141.987 106.771 138.184 110.595 138.184 115.312C138.184 120.03 141.987 123.854 146.679 123.854Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.398 162.394C115.368 162.394 118.586 159.158 118.586 155.166C118.586 151.174 115.368 147.938 111.398 147.938C107.428 147.938 104.209 151.174 104.209 155.166C104.209 159.158 107.428 162.394 111.398 162.394Z",
    fill: "#85B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.156 141.37C127.126 141.37 130.345 138.134 130.345 134.142C130.345 130.15 127.126 126.914 123.156 126.914C119.186 126.914 115.968 130.15 115.968 134.142C115.968 138.134 119.186 141.37 123.156 141.37Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.92 151.885C138.89 151.885 142.109 148.649 142.109 144.657C142.109 140.665 138.89 137.429 134.92 137.429C130.95 137.429 127.732 140.665 127.732 144.657C127.732 148.649 130.95 151.885 134.92 151.885Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.679 122.54C150.649 122.54 153.867 119.304 153.867 115.312C153.867 111.32 150.649 108.084 146.679 108.084C142.709 108.084 139.49 111.32 139.49 115.312C139.49 119.304 142.709 122.54 146.679 122.54Z",
    fill: "#85B8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 150.324,
    y1: 416,
    x2: 150.324,
    y2: 94.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 95879.1,
    y1: 94.6716,
    x2: 95879.1,
    y2: 56365.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5361,
    y1: 64.0624,
    x2: 5361,
    y2: 41768.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 200216,
    y1: 92932.6,
    x2: 200216,
    y2: 5132.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 52713.5,
    y1: 26915.6,
    x2: 52713.5,
    y2: 17592.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 5781.22,
    y1: -6829.73,
    x2: 5244.33,
    y2: -6829.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 6131.87,
    y1: -7505.91,
    x2: 5595.16,
    y2: -7505.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 6513.9,
    y1: -7185.48,
    x2: 5977.18,
    y2: -7185.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 6856.45,
    y1: -8124.59,
    x2: 6319.57,
    y2: -8124.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 464,
    height: 416,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgConclusion);
export default __webpack_public_path__ + "static/media/imgConclusion.2d4531272bb3a20c8e0db7962bdbb597.svg";
export { ForwardRef as ReactComponent };